import React, { useState, useEffect } from "react";
import { companyInfo } from "../data/mock";
import { MessageCircle, X } from "lucide-react";

export const WhatsAppFloat = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (visible) {
      const tooltipTimer = setTimeout(() => setShowTooltip(true), 4000);
      return () => clearTimeout(tooltipTimer);
    }
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* Tooltip */}
      {showTooltip && (
        <div className="relative bg-white rounded-2xl shadow-2xl shadow-slate-900/15 p-4 max-w-[260px] animate-slide-up">
          <button
            onClick={() => setShowTooltip(false)}
            className="absolute top-2 right-2 text-slate-400 hover:text-slate-600 transition-colors"
          >
            <X className="w-3.5 h-3.5" />
          </button>
          <p className="text-sm text-slate-700 font-medium leading-snug pr-4">
            Need quick support? Chat with us instantly on WhatsApp!
          </p>
          <div className="mt-2 flex gap-2 flex-wrap">
            <span className="text-[11px] bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded-full font-medium">
              Quick Enquiry
            </span>
            <span className="text-[11px] bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded-full font-medium">
              Pickup Booking
            </span>
          </div>
        </div>
      )}

      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/${companyInfo.whatsapp}?text=Hi%20AM%20Scrap%20Dealers%2C%20I%20would%20like%20to%20enquire%20about%20your%20scrap%20services.`}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative"
      >
        <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-20" />
        <div className="relative w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-xl shadow-green-900/25 hover:scale-110 transition-transform duration-300">
          <MessageCircle className="w-6 h-6 text-white" />
        </div>
      </a>
    </div>
  );
};
